/**
 * ID生成工具类
 * 统一管理所有类型的ID生成逻辑
 */
export default class IdGenerator {
    /**
     * 生成唯一ID
     * @param {string} prefix - ID前缀（如 'player', 'room', 'team'）
     * @param {Object} options - 选项
     * @param {boolean} options.includeCounter - 是否包含计数器（默认false）
     * @param {number} options.counter - 计数器值（如果includeCounter为true）
     * @returns {string} 生成的ID
     */
    static generate(prefix, options = {}) {
        const { includeCounter = false, counter = null } = options;
        const timestamp = Date.now();
        const random = Math.random().toString(36).substring(2, 9);
        
        if (includeCounter && counter !== null) {
            return `${prefix}_${timestamp}_${random}_${counter}`;
        }
        
        return `${prefix}_${timestamp}_${random}`;
    }
    
    /**
     * 生成敌人ID
     * @param {string} baseId - 基础ID（可选）
     * @returns {string} 敌人ID
     */
    static generateEnemyId(baseId = null) {
        if (baseId) {
            return baseId;
        }
        return this.generate('enemy');
    }
    
    /**
     * 生成NPC ID
     * @param {number} index - NPC索引
     * @returns {string} NPC ID
     */
    static generateNPCId(index) {
        return `npc_${index}_${Date.now()}`;
    }
}

